import React, { useEffect, useState } from "react";
import UnitGuideEditorContent from "./curriculum/UnitGuideEditorContent";
import "./UnitGuideEditorModal.css";

const UnitGuideEditorModal = ({ isOpen, onClose, courses = [] }) => {
  const [selectedCourseId, setSelectedCourseId] = useState("");

  useEffect(() => {
    if (!isOpen) return;
    setSelectedCourseId((prev) => prev || courses[0]?.id || "");
  }, [courses, isOpen]);

  if (!isOpen) return null;

  return (
    <div className="unit-guide-editor-modal" onClick={onClose}>
      <div
        className="unit-guide-editor-panel"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="unit-guide-editor-header">
          <div>
            <h3>Unit Guide Editor</h3>
            <p>Edit rows from `unit_guides` and `unit_guide_sections` by course and unit.</p>
          </div>
          <div className="unit-guide-editor-header-actions">
            <button
              type="button"
              className="unit-guide-editor-close-btn"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>

        <div className="unit-guide-editor-controls">
          <label htmlFor="unit-guide-editor-course">
            Course
            <select
              id="unit-guide-editor-course"
              value={selectedCourseId}
              onChange={(e) => setSelectedCourseId(e.target.value)}
            >
              {courses.map((course) => (
                <option key={course.id} value={course.id}>
                  {course.name}
                </option>
              ))}
            </select>
          </label>
        </div>

        {selectedCourseId && (
          <UnitGuideEditorContent courseId={selectedCourseId} />
        )}
      </div>
    </div>
  );
};

export default UnitGuideEditorModal;
